import React, { useState } from "react";
//import { Modal, Row, Col } from 'react-bootstrap'
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { TransparentButton, SolidButton } from "../../library/button";
import { Popup } from "../../library/popup";
import { changeUniversalModal } from "../../../redux/actions/universal";
import { loadStripe } from "@stripe/stripe-js";
import { sendErrorNotification } from "../notifications/notifications";
import "./style.scss";

const Index = () => {
  const stripePromise = loadStripe(
    `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`
  );

  const dispatch = useDispatch();

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const modalState = useSelector(
    (state) => state.universal.showModals.resubscribeModal
  );
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    dispatch(changeUniversalModal({ resubscribeModal: false }));
  };

  const clickResubscribe = async () => {
    try {
      setLoading(true);
      const stripe = await stripePromise;
      fetch("/api/stripe/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "resubscribe",
          trial: false,
          companyId: selectedCompany,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          stripe.redirectToCheckout({ sessionId: result.sessionId });
        });
    } catch (e) {
      sendErrorNotification("Kunne ikke gå til betaling.");
      setLoading(false);
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Start et nytt abonnement"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={handleClose}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Går til betaling..." : "Gå til betaling"}
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin" />
            ) : (
              <i class="fad fa-shopping-cart" />
            )
          }
          onClick={() => clickResubscribe()}
          type="button"
        />,
      ]}
    >
      <div className="resubscribe-modal-content">
        <p className="description">
          Dersom du ikke har et aktivt abonnement kan du starte et nytt et raskt
          og enkelt i feltet nedenfor.
        </p>
        <div className="select-plan-container">
          <div className="single-selection-container active">
            <div className="inner-single-selection-container">
              <Row>
                <Col className="button-col my-auto">
                  <button className="select-button">
                    <i class="fad fa-circle"></i>
                  </button>
                </Col>
                <Col className="details-col my-auto">
                  <h4 className="plan-title">Standard abonnement</h4>
                  <p className="plan-description">
                    Pris oppgitt er eksklusiv moms
                  </p>
                </Col>
                <Col className="price-col my-auto">
                  <span className="price-display">
                    399kr<span className="small">per måned</span>
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default Index;
